<div class="main-container">
  <div class="row">
    <div class="column left">
      <h3>Finished Oil</h3>
    </div>
    <div class="column right">
      <div class="row buttons">
        <button
          class="blue-button save-fav-btn"
          (click)="openSaveDialog()"
          title="Save current blend as a favorite">
          <span class="material-icons-outlined btn-icon">bookmark</span>
          <span>Save Favorite</span>
        </button>
        <button
          ngbAccordionButton
          class="blue-button"
          (click)="executePrediction()"
          [disabled]="!canExecutePrediction || isExecutingPrediction"
          [title]="
            !canExecutePrediction
              ? 'A Package and a Base Oil ratio total of 100 are required'
              : 'Execute prediction'
          "
        >
          <span *ngIf="!isExecutingPrediction">Execute Prediction</span>
          <span *ngIf="isExecutingPrediction">Executing...</span>
        </button>
        <button
          type="button"
          class="blue-button"
          (click)="openWeightCalculator()"
          title="Open Weight Calculator">
          Weight Calculator
        </button>
      </div>
    </div>

    <!-- Save Favorite Mini-Modal -->
    <div class="save-fav-overlay" *ngIf="showSaveDialog" (click)="cancelSaveDialog()">
      <div class="save-fav-dialog" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="dialog-close"
          aria-label="Close"
          [disabled]="isSaving"
          (click)="cancelSaveDialog()">&times;</button>
        <h4>Save Favorite</h4>
        <input
          type="text"
          class="save-fav-input"
          [ngModel]="saveFavoriteName"
          (ngModelChange)="onSaveNameChange($event)"
          placeholder="Enter favorite name"
          [disabled]="isSaving"
          (keyup.enter)="confirmSaveFavorite()" />
        <p class="save-error" *ngIf="saveError">{{ saveError }}</p>
        <div class="save-fav-actions">
          <button
            class="btn-confirm"
            (click)="confirmSaveFavorite()"
            [disabled]="!saveFavoriteName.trim() || isSaving">
            <span *ngIf="!isSaving">Save</span>
            <span *ngIf="isSaving">Saving...</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Overwrite Confirmation Mini-Modal -->
    <div class="save-fav-overlay" *ngIf="showOverwriteConfirm" (click)="cancelOverwrite()">
      <div class="save-fav-dialog" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="dialog-close"
          aria-label="Close"
          (click)="cancelOverwrite()">&times;</button>
        <h4>Overwrite Favorite</h4>
        <p class="overwrite-text">
          A favorite named "{{ pendingOverwrite?.name }}" already exists. Overwrite it?
        </p>
        <div class="save-fav-actions">
          <button
            class="btn-confirm"
            (click)="confirmOverwrite()"
            [disabled]="isSaving">
            <span *ngIf="!isSaving">Overwrite</span>
            <span *ngIf="isSaving">Saving...</span>
          </button>
        </div>
      </div>
    </div>
    <div class="second-row">
      <div class="first-column">
        <div class="row radio-buttons">
          <label class="custom-radio">
            <input
              class="no-radio-button"
              type="radio"
              name="finishedOilOption"
              value="modifications"
              [(ngModel)]="selectedFinishedOilOption"
            />
            <span class="checkmark" (click)="scrollToTop()">Modification</span>
          </label>
          <label class="custom-radio">
            <input
              class="no-radio-button"
              type="radio"
              name="finishedOilOption"
              value="contents"
              [(ngModel)]="selectedFinishedOilOption"
            />
            <span class="checkmark" (click)="scrollToPC()"
              >Package Contents</span
            >
          </label>
        </div>
      </div>
      <div class="second-column">&nbsp;</div>
      <div class="second-column">
        <button class="secondary adapted" (click)="openModal1()">
          Model Inputs 1
        </button>
      </div>
      <div class="second-column">&nbsp;</div>
      <div class="second-column">
        <button class="secondary adapted" (click)="openModal2()">
          Model Inputs 2
        </button>
      </div>
    </div>
  </div>
  <app-bc-fob-modification
    id="blend-modification"
    #modificationComponent
    class="full component-box"
  ></app-bc-fob-modification>
  <app-bc-fob-packages
    id="package-contents"
    #packageComponent
    class="full component-box"
    (tableDataChange)="onTableDataChange($event)"
  ></app-bc-fob-packages>
  <button class="go-up" (click)="scrollToTop()">Go up</button>
</div>

<app-bc-weight-calculator
  [isOpen]="isWeightCalculatorOpen"
  [context]="weightCalculatorContext"
  (closed)="closeWeightCalculator()">
</app-bc-weight-calculator>

<!-- Modal for Model Inputs (reusable) -->
<div
  class="modal-overlay"
  *ngIf="isModal1Open || isModal2Open"
  (click)="closeModals()"
>
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <span class="modal-title"
        >Model Inputs {{ isModal1Open ? "1" : "2" }}</span
      >
      <button class="close-btn" (click)="closeModals()">×</button>
    </div>
    <div class="modal-body">
      <!-- Modal 1 -->
      <app-bc-fob-model-inputs
        *ngIf="isModal1Open"
        [blendNumber]="1"
        [packageData]="currentPackageData"
        [vmData]="vmSelectedData"
        (close)="closeModals()"
      >
      </app-bc-fob-model-inputs>

      <!-- Modal 2 -->
      <app-bc-fob-model-inputs
        *ngIf="isModal2Open"
        [blendNumber]="2"
        [packageData]="currentPackageData"
        [vmData]="vmSelectedData"
        (close)="closeModals()"
      >
      </app-bc-fob-model-inputs>
    </div>
  </div>
</div>
